/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
    {
        _id: "rue8-jvbc9I",
        title: "Splendor - How To Play",
        youtubeID: "rue8-jvbc9I",
        videoLength: "9:03",
        videoThumbnail: "http://i3.ytimg.com/vi/rue8-jvbc9I/hqdefault.jpg",
        likes: 5021,
        views: 398824,
        category: "Game Play",
        channelName: "Watch It Played",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLTlCQyNzlI-dn-gr9YC4qMSnzte0OugC2I5lP7r=s88-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCGK9n7svoIjuaQfRIBJXkqQ",
        subscribers: "276K",
        dateOfUpload: "Apr 15, 2015",
        description:
            "In this video we're going to learn how to play Splendor! If you have any comments or questions, please do not hesitate to post them in the YouTube comments below, ensuring you abide by our Code of Conduct: https://watchitplayed.tv/code-of-conduct.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "pbbD_Qn4dY4",
        title: "How to Make Game Boards - Dining Table Print and Play",
        youtubeID: "pbbD_Qn4dY4",
        videoLength: "15:38",
        videoThumbnail: "http://i3.ytimg.com/vi/pbbD_Qn4dY4/hqdefault.jpg",
        likes: 4792,
        views: 198388,
        category: "Diy",
        channelName: "Dining Table Print & Play",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLSqIHRzL-wgI1oWE0GQ-8ILvunZD7we-P1UTrqe=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCkaY1WTL4vtJHJDxY4KqAVQ",
        subscribers: "10.6K",
        dateOfUpload: "Oct 27, 2016",
        description:
            "A tutorial on how to make game boards for your print & play board games, including a number of little tips and tricks to make the process easier. Everything from simple taped-together paper boards to vinyl-wrapped boards to rival commercial products is covered.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "oAtbEi38njY",
        title: "Board Game Unboxing Haul 7/31/2021-10 Games!!",
        youtubeID: "oAtbEi38njY",
        videoLength: "24:52",
        videoThumbnail: "http://i3.ytimg.com/vi/oAtbEi38njY/hqdefault.jpg",
        likes: 64,
        views: 1632,
        category: "Unboxing",
        channelName: "We Game Together",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLQK6Sca7kCQxWDqVHc6lcTZoW3U9aZHV8Cc2uUG=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCHv62yMzLn92_pevWlQo09g",
        subscribers: "3.3K",
        dateOfUpload: "Aug 2, 2021",
        description:
            "Randy and Ellen from We Game Together open stuff on this unboxing of a bunch of games! Buy Merch Here!! wegametogether.redbubble.com",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "6TkQovpJhdU",
        title: "TOP 10 BOARD GAMES! A Modern, Cinematic List Going into 2022",
        youtubeID: "6TkQovpJhdU",
        videoLength: "24:43",
        videoThumbnail: "http://i3.ytimg.com/vi/6TkQovpJhdU/hqdefault.jpg",
        likes: 4651,
        views: 177825,
        category: "All time favourites",
        channelName: "Tim Chuon",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLSy_dGDmlRs1dXTnw0Wsyk4zUZitBkxLp1x6Uc3VA=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UC1WByNzqXBEGwgXNa05rpYQ",
        subscribers: "13.3K",
        dateOfUpload: "Jan 3, 2022",
        description:
            "Here are the TOP 10 board games as we head full force into 2022! These games consist of favorites that I played in 2021-just didn't have a chance to film them during the holidays! Join me as I share really awesome games that I absolutely love!",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "4JhFhyvGdik",
        title: "Ticket to Ride - How To Play",
        youtubeID: "4JhFhyvGdik",
        videoLength: "10:44",
        videoThumbnail: "http://i3.ytimg.com/vi/4JhFhyvGdik/hqdefault.jpg",
        likes: 5493,
        views: 597702,
        category: "Game Play",
        channelName: "Watch It Played",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLTlCQyNzlI-dn-gr9YC4qMSnzte0OugC2I5lP7r=s88-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCGK9n7svoIjuaQfRIBJXkqQ",
        subscribers: "276K",
        dateOfUpload: "Jan 24, 2018",
        description:
            "In this video we're going to learn how to play Ticket To Ride! If you have any comments or questions, please do not hesitate to post them in the YouTube comments below, ensuring you abide by our Code of Conduct: https://watchitplayed.tv/code-of-conduct.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "PwylKBlrhrM",
        title: "Ticket to Ride Strategy",
        youtubeID: "PwylKBlrhrM",
        videoLength: "13:03",
        videoThumbnail: "http://i3.ytimg.com/vi/PwylKBlrhrM/hqdefault.jpg",
        likes: 182,
        views: 25067,
        category: "Strategy",
        channelName: "Taming Games",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLQrg9wkE9tlWhQA4GKOyIK92ozbUJV73pKZAm8h=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCSWqfAneMiVYailJRaordkQ",
        subscribers: "860",
        dateOfUpload: "Oct 15, 2020",
        description:
            "In this video, I walk you through how to set-up the strategies, what actions you need to take for full advantage of the strategy, and when to use the strategy.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "QE7_Q5klSeA",
        title: "The rebirth of board games and the new social revolution | Drew Blas | TEDxTopeka",
        youtubeID: "QE7_Q5klSeA",
        videoLength: "13:46",
        videoThumbnail: "http://i3.ytimg.com/vi/QE7_Q5klSeA/hqdefault.jpg",
        likes: 373,
        views: 31079,
        category: "All time favourites",
        channelName: "TEDx Talks",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLQGnY6McntoY-eWaRDI047FWFqj7pVlw2nBfkwz7w=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCsT0YIqwnpJCM-mx7-gSA4Q",
        subscribers: "34.6M",
        dateOfUpload: "Apr 7, 2015",
        description:
            "Technology has powered a whole new paradigm of virtual “social” interaction and Facebook and its ilk are common household names that pervade our culture. But at dinner tables, coffee houses, and bars all across the world, a completely different social revolution is taking place: Board gaming.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "d8aJrYu5_60",
        title: "Creature Comforts Board Game Unboxing | Danicha",
        youtubeID: "d8aJrYu5_60",
        videoLength: "6:27",
        videoThumbnail: "http://i3.ytimg.com/vi/d8aJrYu5_60/hqdefault.jpg",
        likes: 7,
        views: 102,
        category: "Unboxing",
        channelName: "DaniCha",
        channelThumbnail:
            "https://yt3.ggpht.com/iKIojWJ8yIS1A-2TLBJDc03794K3SSj7H3f3wZnRGehm6oKE6wYBW-YEIy3rQHEH_Fwk3qkVbQ=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UC8EUL0E_Y0rDEOibJmQd0Fw",
        subscribers: "607",
        dateOfUpload: "Apr 8, 2022",
        description:
            "Follow me on IG @danicha.plays https://www.instagram.com/danicha.plays/",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "-xqFavHI0AI",
        title: "How to make diy board game/board games making at home/make your own board game/easy board game ideas",
        youtubeID: "-xqFavHI0AI",
        videoLength: "5:16",
        videoThumbnail: "http://i3.ytimg.com/vi/-xqFavHI0AI/hqdefault.jpg",
        likes: 835,
        views: 55822,
        category: "Diy",
        channelName: "A to Z Handmade Creations",
        channelThumbnail:
            "https://yt3.ggpht.com/HXJGH3va5c7Ue_1C336AQCeKNw-HJFKzHle899SD-tFtGdrcvhtv6haCUeV9m5waj6DANufR5Q=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCqN6SP-ITcYhO1SiWfLgLRQ",
        subscribers: "37.2K",
        dateOfUpload: "Mar 5, 2021",
        description: "Rule of this game https://youtu.be/Ef8TM2kLbfg",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "i5oDYwbUfp4",
        title: "TOP 10 BOARD GAMES Of ALL TIME 2021 from Legendary Tactics / 30 best tabletop games",
        youtubeID: "i5oDYwbUfp4",
        videoLength: "25:40",
        videoThumbnail: "http://i3.ytimg.com/vi/i5oDYwbUfp4/hqdefault.jpg",
        likes: 556,
        views: 49653,
        category: "All time favourites",
        channelName: "Legendary Tactics",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLSQS2-_JRj1MIDwMRKnPYtCHd21w-TzeHHeaKA4_g=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCRarNme4iUanPLflogg-Ntg",
        subscribers: "9.03K",
        dateOfUpload: "Jan 26, 2021",
        description:
            "This video will succinctly share our favourite board games of all time. We'll each give you our top 10 games X 3. We'll put timestamps down in the comment section so you can get to the good bits quickly, and please be sure to let us know whose list is the best because we are perennially trying to beat each other at everything we do. Coming up are our favourite 30 board games. Let us know in the comments, whose list is the best and please share your lists with us too.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "rfnYMfDZVY4",
        title: "I Never Lose at Splendor | Game Breakers | Strategy",
        youtubeID: "rfnYMfDZVY4",
        videoLength: "4:19",
        videoThumbnail: "http://i3.ytimg.com/vi/rfnYMfDZVY4/hqdefault.jpg",
        likes: 182,
        views: 25067,
        category: "Strategy",
        channelName: "Obsessive Board Gamers",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLQZ-QlCRF-RiHG-ybHJLOCc1qmL7Fp7LUFwkbDy=s88-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCU-HLafvwDgWrfGTCy2P4Ew",
        subscribers: "1.9K",
        dateOfUpload: "Feb 28, 2019",
        description:
            "I have never lost a game of Splendor, and that's not a good thing. There are very few board games that we actually dislike. There are, however, many games that come down to only a single strategy, even when they present many paths to victory. Join us for another Game Breaker.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "e4yhmBgFzjo",
        title: "Top 50 Board Games of ALL-TIME! | 10-1 (Top 10 Board Games of All-Time!)",
        youtubeID: "e4yhmBgFzjo",
        videoLength: "1:08:38",
        videoThumbnail: "http://i3.ytimg.com/vi/e4yhmBgFzjo/hqdefault.jpg",
        likes: 981,
        views: 39069,
        category: "All time favourites",
        channelName: "All You Can Board",
        channelThumbnail:
            "https://yt3.ggpht.com/_cuH3n-SJJ8Hlw2Ayei_acMAHWzl6QhSOkVr2hEi68dGnVbWd79OhBEVj9x914bWVsytFZdqnw=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCoea2MYUGi1qK_82OZF8BkA",
        subscribers: "11.1K",
        dateOfUpload: "Dec 30, 2021",
        description:
            "For the first time ever, we're counting down our top 50 games of all-time! As of the filming of these videos, we've each played somewhere around ~300 games, so our top 50 represents approximately the best 17% of the games we've played.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "tZIug8ZZuFg",
        title: "Make Your Own Board Games!",
        youtubeID: "tZIug8ZZuFg",
        videoLength: "7:52",
        videoThumbnail: "http://i3.ytimg.com/vi/tZIug8ZZuFg/hqdefault.jpg",
        likes: 269,
        views: 11618,
        category: "Diy",
        channelName: "MrFixIt DIY",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLTrTZk0HMgXXmCtfk-5R2PL2ejxqkYMni53zlA6=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCV_nOXaNjfVViN-NI1nb1Ig",
        subscribers: "192K",
        dateOfUpload: "Dec 24, 2019",
        description:
            "In this final video of my homemade holiday series, I'll show you how to build your own hardwood board games for your friends and family that can last for years! Thanks to my friends at Carhartt for sponsoring this special Holiday series and make sure you watch the full series for more ideas! Happy Holidays!",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "Q6EXhwiNVEA",
        title: "Popular Board Games of All Time 2014-2020",
        youtubeID: "Q6EXhwiNVEA",
        videoLength: "10:17",
        videoThumbnail: "http://i3.ytimg.com/vi/Q6EXhwiNVEA/hqdefault.jpg",
        likes: 514,
        views: 69734,
        category: "All time favourites",
        channelName: "Board Game Atlas",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLRwsITxvvtmrTn7dLrLvw8ubAgiiidnWtWt63-c3w=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCbz9V1I0cZ2IOMJFJFBIFZQ",
        subscribers: "3.52K",
        dateOfUpload: "Jul 8, 2020",
        description:
            "Here's a video that captures the trend of the most popular board games since 2014 using the traffic data from Board Game Atlas and Board Game Prices. You can find more information on how I created the video here: https://www.boardgameatlas.com/forum/...",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "lPlBDZnxHQA&t",
        title: "Coup - How To Play",
        youtubeID: "lPlBDZnxHQA",
        videoLength: "14:13",
        videoThumbnail: "http://i3.ytimg.com/vi/lPlBDZnxHQA/hqdefault.jpg",
        likes: 1842,
        views: 144511,
        category: "Game Play",
        channelName: "Watch It Played",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLTlCQyNzlI-dn-gr9YC4qMSnzte0OugC2I5lP7r=s88-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCGK9n7svoIjuaQfRIBJXkqQ",
        subscribers: "276K",
        dateOfUpload: "Feb 20, 2017",
        description:
            "In this video, we're going to learn how to play Coup! If you have any comments or questions, please do not hesitate to post them in the YouTube comments below.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "WovgJQKRk_Q",
        title: "Settlers of Catan: 9 Every Game Tips & Tricks",
        youtubeID: "WovgJQKRk_Q",
        videoLength: "6:25",
        videoThumbnail: "http://i3.ytimg.com/vi/WovgJQKRk_Q/hqdefault.jpg",
        likes: 2984,
        views: 288799,
        category: "Strategy",
        channelName: "Treeckosaurus [Catan]",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLRBmBeRVYIdCxZtFzm7KF0PRf7n1xj2-Ew6SibLKg=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCBZVN0IP1Zj1ggW1gSkZECQ",
        subscribers: "2.96K",
        dateOfUpload: "Apr 20, 2019",
        description:
            "The Settlers of Catan tips and tricks you'll learn in this video can be applied in every single game you play. These are actionable rules of thumb and strategies I use to have a 1200+ ELO on Catan Universe and to beat my friends and family consistently in a game of Catan.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "fPwsSlmF2zk",
        title: "Unboxing game of LIFE, how to assemble LIFE|| super sanvi",
        youtubeID: "fPwsSlmF2zk",
        videoLength: "7:50",
        videoThumbnail: "http://i3.ytimg.com/vi/fPwsSlmF2zk/hqdefault.jpg",
        likes: 283,
        views: 19367,
        category: "Unboxing",
        channelName: "Super Sanvi",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLTxM5t5KMiJMjjLS8RZ-BjLpmlnr-g_bc_lxyX1AA=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCkTgmZRylFmywin3sjPrdwQ",
        subscribers: "17.2K",
        dateOfUpload: "Dec 29, 2019",
        description:
            "Bought my christmas gift the super duper exiting game of LIFE, so wanted to share with you all how this game is assembled, and how it looks from inside by unboxing",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "n3t1LHk7h0A",
        title: "How to play Dragonwood | HOW TO PLAY",
        youtubeID: "n3t1LHk7h0A",
        videoLength: "4:03",
        videoThumbnail: "http://i3.ytimg.com/vi/n3t1LHk7h0A/hqdefault.jpg",
        likes: 289,
        views: 43827,
        category: "Game Play",
        channelName: "Zia Comics",
        channelThumbnail:
            "https://yt3.ggpht.com/8B_0gK_GM6W196I6es8uMPm0rlh9AgzyzwOmhpBnMgk9AaD_045K1mdN-eQlirSUDJueWESLJD8=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCZhRyzRgXdM8aXyn7FPJUuA",
        subscribers: "2.5K",
        dateOfUpload: "Apr 1, 2016",
        description:
            "Danny McKinley from ZiaComics.com teaches us how to play Dragonwood by Gamewright.	Dare to enter Dragonwood! Deep in the heart of this mythical forest lurk angry ogres, giggling goblins, and even the famed and fearsome fire-breathers themselves! In Dragonwood, you collect sets of adventurer cards to earn dice, which you then use to roll against your foes. Stomp on some fire ants, scream at a grumpy troll, or strike the menacing orange dragon with a magical silver sword. Choose your strategy carefully because the landscape of Dragonwood is ever-changing. Only the bravest will overcome the odds to emerge victorious!",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "Hqpo0kTN6Y0",
        title: "Century: Spice Road - GameNight! Se4 Ep32 - How to Play and Playthrough",
        youtubeID: "Hqpo0kTN6Y0",
        videoLength: "1:14:47",
        videoThumbnail: "http://i3.ytimg.com/vi/Hqpo0kTN6Y0/hqdefault.jpg",
        likes: 737,
        views: 71124,
        category: "Game Play",
        channelName: "BoardGameGeek",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLSkqyyeVsdxeKb8TKIrFwjaZrzX41RHmZWnZ0XQ=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UC3kCMqa1tEnlPyt0fvFUS0A",
        subscribers: "136K",
        dateOfUpload: "May 4, 2017",
        description:
            "Intro: 0:00, Game play: 7:10, End Game Discussion: 59:00, Tonight on GameNight! Nikki, Dave, Stephanie, Aaron & Lincoln teach and show you how to play Century: Spice Road designed by Emerson Matsuuchi and published by Plan B Games.",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "4sTWbtpk_I4",
        title: "DIY Gaming - How to Make a Tri-fold Gameboard",
        youtubeID: "4sTWbtpk_I4",
        videoLength: "15:03",
        videoThumbnail: "http://i3.ytimg.com/vi/4sTWbtpk_I4/hqdefault.jpg",
        likes: 1054,
        views: 65810,
        category: "Diy",
        channelName: "Pub Meeple",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLRAJOqAHTUyYGw8S8cbv3spmLa1cgtTnq5FzaETeg=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCdlK2PUqXgN8XBGnrsJnX8g",
        subscribers: "5K",
        dateOfUpload: "Mar 11, 2015",
        description:
            "More commonly known as the quadrifold game board, the true tri-fold's secrets are released in this tutorial on how to make game boards!",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
    {
        _id: "lx_7QyD7A3s",
        title: "TOP 3 FAVORITE Board Games",
        youtubeID: "lx_7QyD7A3s",
        videoLength: "32:21",
        videoThumbnail: "http://i3.ytimg.com/vi/lx_7QyD7A3s/hqdefault.jpg",
        likes: 1051,
        views: 14950,
        category: "All time favourites",
        channelName: "DiceCheck",
        channelThumbnail:
            "https://yt3.ggpht.com/ytc/AKedOLTqIb44t-1_b_8iSn6NRssSkzS9KEBxs1Xqa_C3Gg=s48-c-k-c0x00ffffff-no-rj",
        channelLink: "https://www.youtube.com/channel/UCgvT6ZJTJ_n73aeise8BOiQ",
        subscribers: "107K",
        dateOfUpload: "Feb 17, 2021",
        description: "TWITCH: http://twitch.tv/dicecheck UNFOLD FOR MORE GOODIES!",
        comments: [
            {
                userName: "Amar",
                comment: "Thanks for the video, this really helped",
                commentDate: "Oct 12, 2021",
                color: "red",
            },
            {
                userName: "Shakti",
                comment: "I love this board game",
                commentDate: "Mar 16, 2022",
                color: "blue",
            },
        ],
    },
];
